export class EventLocation {
  constructor(
    public name: string = '',
    public address: string = '',
    public latitude?: number,
    public longitude?: number,
  ) {}
}
